import request from '@/axios/index.js'
const uri = '/user/buyrPym/';
export function pagingGldInfList(data,loading) {
    return request.axios({
        url: uri+'pagingGldInfList',
        data: data,
        loading:loading
    })
}
export function recordApi(data,loading) {
    return request.axios({
        url: uri+'record',
        data: data,
        loading:loading
    })
}
export function getBuyrPymClsfDtlDetail(data,loading) {
    return request.axios({
        url: uri+'getBuyrPymClsfDtlDetail',
        data: data,
        loading:loading
    })
}
export function rcPtyList(data,loading) {
    return request.axios({
        url: uri+'rcPtyList',
        data: data,
        loading:loading
    })
}
// 查看付款通知
export function getGoldTicketInfo(data,loading) {
    return request.axios({
        url: '/user/buyrPym/getPymNoticeFile',
        data: data,
        loading:loading
    })
}
// 法律文本查看状态修改
export function PymNoticeFileSeen(data,loading) {
    return request.axios({
        url: '/user/buyrPym/PymNoticeFileSeen',
        data: data,
        loading:loading
    })
}
// 祺信兑付
export function BuyerGoldcheckPayAPI(data,loading) {
    return request.axios({
        url: '/user/buyrPym/gldPym',
        data: data,
        loading:loading
    })
}
// 祺信兑付验证付款信息
export function checkGldInf(data,loading) {
    return request.axios({
        url: '/user/buyrPym/checkGldInf',
        data: data,
        loading:loading
    })
}
// 是否显示付款通知书按钮
export function isShowPymNoticeFile(data,loading) {
    return request.axios({
        url: '/user/buyrPym/isShowPymNoticeFile',
        data: data,
        loading:loading
    })
}






// WEBPACK FOOTER //
// ./src/api/buyrPym.js